import { useQuery } from "@apollo/client"

import { COACH_TOOLS_API } from "../apolloClient"
import {
  DASHBOARD_PGM_GRADUATE_QUERY,
  MEMBER_APPLICATION_ELIGIBILITY_QUERY,
} from "../components/queries/memberApplicationEligibility"

export function usePgmGraduate({ skip = false } = {}) {
  const { data, loading, error } = useQuery(DASHBOARD_PGM_GRADUATE_QUERY, {
    context: { api: COACH_TOOLS_API },
    skip,
  })

  return {
    pgmGraduate: data?.currentPerson?.pgmGraduate === true,
    loading: skip ? false : loading,
    error: skip ? undefined : error,
  }
}

/**
 * Runs memberApplicationEligibility for graduated PGM students.
 * Call from Dashboard like useMembershipJourney; the result is unused on Account
 * (blocking reasons stay on the GraphQL response / mobile My Applications).
 */
export function useMemberApplicationEligibility({ skip = false } = {}) {
  const { pgmGraduate, loading, error } = usePgmGraduate({ skip })
  useQuery(MEMBER_APPLICATION_ELIGIBILITY_QUERY, {
    context: { api: COACH_TOOLS_API },
    fetchPolicy: "network-only",
    errorPolicy: "all",
    skip: skip || loading || !pgmGraduate,
  })

  return { pgmGraduate, loading, error }
}
